import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';

const SrUtilitySetupTransferInternetFlowReplaceModem = ({ providerName, onSubmit, onBack }) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-lighting.png"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      maxWidth="320px"
      maxIconHeight="100px"
      maxIconWidth="100px"
      headline={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="26px" weight="800" font="greycliff" display="block">
            Replace your outdated modem with the newest&nbsp;
            {providerName || 'modem'} model on the market.
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox maxWidth="250px" margin="0 auto">
          <SrText font="greycliff" fontSize="16px" lineHeight="25px" weight="600" align="center">
            {providerName || 'Your internet provider'} offers this at no additional cost.
          </SrText>
        </SrBox>
      }
      srMultiButtons={[
        {
          buttonText: 'Next',
          onButtonClick: onSubmit,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
        {
          buttonText: 'Back',
          onButtonClick: onBack,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilitySetupTransferInternetFlowReplaceModem.propTypes = {
  providerName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SrUtilitySetupTransferInternetFlowReplaceModem.displayName =
  'SrUtilitySetupTransferInternetFlowReplaceModem'; // eslint-disable-line max-len

export default SrUtilitySetupTransferInternetFlowReplaceModem;
